module.exports = __webpack_public_path__ + "img/ic_zhipiao.e9447a86.png";